export default __webpack_public_path__ + "static/funnel-experiment-calculation-light-01700db7b18f051c0cf24584b74c3683.png";